import { Alert, Table } from 'antd'
import { FC } from 'react'
import Filter from '../Filter/Filter'

import style from './style.m.less'

import { openedDataSource } from './data'
import { openedColumns } from './columns'
import { useNavigate } from 'react-router-dom'

const Opened: FC = () => {
    const navigate = useNavigate()

    if (!openedDataSource || openedDataSource.length === 0) {
        return (
            <Alert
                message="У вас пока нет новых заявок на согласование"
                type="info"
                showIcon
                className={style.alert}
            />
        )
    }

    return (
        <div className={style.opened}>
            <Filter />
            <div className={style.table}>
                <Table
                    dataSource={openedDataSource}
                    columns={openedColumns}
                    pagination={{
                        position: ['bottomLeft'],
                    }}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate('/zd-approval/' + record.key)
                        },
                    })}
                />
            </div>
        </div>
    )
}

export default Opened
